import React from 'react';
import {Form, Button, Card,CardGroup, CardColumns, Table} from "react-bootstrap";
import {useHistory} from 'react-router-dom';
import MaterialTable from "material-table";
import '../App.css';

function Register() {
    const url = "/api";
    const token = localStorage.getItem('token');
    const [registerOptions, setRegisterOptions] = React.useState({
        email: "admin@asdt.eu",
        ident: "id"
    });
    const [noAuth, setNoAuth] = React.useState([]);
    const history = useHistory();

    const noAuthColumns = [
        {
            title: "ID",
            field: "ident",
            align: 'center'
        },
        {
            title: "Last Attempt",
            field: "lastAttempt",
            align: 'center'
        },

    ];

    async function registerDetector(){
        const userLogged = localStorage.getItem("Login");
        const toJson = {
            "email": userLogged,
            "ident": registerOptions.ident
        }
        console.log(toJson);
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify(toJson)
        }

        let response = await fetch(url + '/register', options).catch(err => {
            console.log(err);
        });
        console.log(response);
        console.log(response.headers);
        console.log(response.body);
        console.log(response.status);
        if(response.status !== 200 ){
            console.log("The detector can't be registered");
            alert("The detector with id: " + registerOptions.ident + " can't be registered :(")
        }
        var dataReceived = await response.json();
        console.log("Detector registered" + dataReceived.result);
        alert("Detector with id: " + registerOptions.ident + " registered!")
    }

    function updateIdent(event){
        setRegisterOptions({
            email: registerOptions.email,
            ident: event.target.value
        });
    }

    async function acceptDetector(event){
        const userLogged = localStorage.getItem("Login");
        const toJson = {
            "email": userLogged,
            "ident": event
        }
        console.log(toJson);
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify(toJson)
        }

        let response = await fetch(url + '/register', options).catch(err => {
            console.log(err);
        });
        console.log(response);
        console.log(response.headers);
        console.log(response.body);
        console.log(response.status);
        if(response.status !== 200 ){
            console.log("The detector can't be accepted");
            alert("The detector with id: " + event + " can't be accepted :(")
        }
        var dataReceived = await response.json();
        console.log("Detector registered" + dataReceived.result);
        alert("Detector with id: " + event + " registered!")
        history.push('/');
    }

    async function denyDetector(event){
        const userLogged = localStorage.getItem("Login");
        const toJson = {
            "ident": event,
            "user": userLogged,
            "action": "deny"
        }
        console.log(toJson);
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
                'x-access-token': token
            },
            body: JSON.stringify(toJson)
        }

        let response = await fetch(url + '/noAuth', options).catch(err => {
            console.log(err);
        });
        console.log(response);
        console.log(response.headers);
        console.log(response.body);
        console.log(response.status);
        if(response.status !== 200 ){
            console.log("The detector can't be denied");
            alert("The detector with id: " + event + " can't be denied :(")
        }
        var dataReceived = await response.json();
        console.log("Detector denied" + dataReceived.result);
        alert("Detector with id: " + event + " denied!")
        history.push('/');
    }

    React.useEffect(() => {
        const months = [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Setiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
        ];
        const days = [
            'Domingo',
            'Lunes',
            'Martes',
            'Miércoles',
            'Jueves',
            'Viernes',
            'Sábado'
        ];
        async function fetchData(){
            let options = {
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*',
                    'Access-Control-Allow-Origin': '*',
                    'x-access-token': token
                },
            }

            let response = await fetch(url + '/noAuth', options).catch(err => {
                console.log(err);
            });
            if(response.status !== 200 ){
                if (response.status === 401) {
                    localStorage.removeItem('token');
                  }
                console.log("Can't get the noAuth information");
            }
            var dataReceived = await response.json();

            var data = [];
            dataReceived.forEach(item => {
                const dateLast = new Date(item.lastAttempt);
                const monthName = months[dateLast.getMonth()];
                const dayName = days[dateLast.getDay()];
                const year = dateLast.getFullYear();
                const dayNum = dateLast.getDate();
                const hours = dateLast.getHours();
                const minutes = dateLast.getMinutes();
                const seconds = dateLast.getSeconds();
                const formattedFecha = `${dayName}, ${dayNum} ${monthName} ${year}`;
                const formattedHora = `${hours}:${minutes}:${seconds}`;
                var lastMessage ="";
                if(dayName !== undefined){
                    lastMessage = formattedFecha + ' a las ' + formattedHora;
                }
                data.push({
                    "ident": item.ident,
                    "lastAttempt": lastMessage
                });
            });

            setNoAuth(data);
           
        }
        fetchData();
    }
    , []);

    return(
        <div>
            <h1>Register Detectors</h1>
            <br></br>
            <br></br>
            <hr></hr>
            
            <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-start', marginTop: '50px', marginBottom: '50px' }}>
                    <Card className="p-3 mb-4 mr-4" style={{ overflowX: 'scroll', width: '500px' , borderRadius: '20px'}}>
                        <Card.Title><strong>Register a Detector</strong></Card.Title>
                        <Card.Body>
                            <Form className="form-registro">
                                <Form.Group controlId="formGridAddress1" className="form-row">
                                    <Form.Label>Detector ID</Form.Label>
                                    <Form.Control placeholder="123ABC456XYZ" onChange={updateIdent}/>
                                </Form.Group>

                                <Button variant="primary" style={{backgroundColor:'#076129', borderColor:'#076129'}} onClick={registerDetector}>
                                    Register
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>

                        
                    <Card className="p-3 mb-4 mr-4" style={{ display: 'flex', width: '700px', overflowX: 'scroll' , borderRadius: '20px'}}>
                    <Card.Title><strong>Not Authenticated Detectors</strong></Card.Title>
                        <Card.Body>
                        <br></br>
                        <MaterialTable
                            title="Pending Detectors Petitions"
                            data={noAuth}
                            columns={noAuthColumns}
                            options={{ search: false, paging: false, padding: 'dense', headerStyle: { fontSize: '1em', paddingLeft: '40px' } }}
                            style={{ textAlign: 'center', borderRadius: '20px'}}
                            localization={
                                {
                                    header: {
                                        actions: ""
                                    }
                                }
                            }
                            actions={[
                                {
                                    icon: 'close',
                                    tooltip: 'Deny Detector',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        denyDetector(rowData.ident);
                                    }
                                },
                                {
                                    icon: 'done',
                                    tooltip: 'Accept Detector',
                                    iconProps: { color: 'action' },
                                    onClick: (event, rowData) => {
                                        acceptDetector(rowData.ident);
                                    }
                                }
                            ]}
                        />
                        </Card.Body>
                    </Card>
            </div>
        </div>
    );
}

export default Register;
